let iframe360timeout,
    onCompleted;

$(function() {
    $('.js-360-start').on('click', function(event) {
        const $startButton = $(this),
            $iframe = $('.js-360-iframe'),
            $wrapper = $('.js-360-wrapper');

        event.preventDefault();

        $wrapper.removeClass('is-loaded');
        $wrapper.addClass('is-loading');

        $iframe.one('load', function() {
            if (iframe360timeout) {
                clearTimeout(iframe360timeout);
            }

            iframe360timeout = setTimeout(function() {
                $wrapper.removeClass('is-loading');
                $wrapper.addClass('is-loaded');
            }, 2500);
        });

        $iframe.attr('src', $('.js-360-select.is-active').data('link'));
    });

    $('.js-360-select').on('click', function(e) {
        e.preventDefault();

        if (!$(this).hasClass('is-active')) {
            $('.js-360-select').removeClass('is-active');
            $(this).addClass('is-active');
            $('.js-360-start').click();
        }
    });

    const $newsletterForm = $('.js-form-subscription');

    if ($newsletterForm.length) {
        $newsletterForm.validate({
            errorPlacement: function(error, element) {
                if (element.attr("type").match("checkbox")) {
                    error.insertAfter(element.siblings("label"));
                } else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function (form) {
                const $emailInput = $('.js-newsletter-email'),
                    $newsletterMessage = $('.js-newsletter-message'),
                    $captchaWrapper = $newsletterForm.find(".captcha-wrapper"),
                    $submitButton = $('.js-newsletter-submit'),
                    $consentCheckbox = $('.newsletter-consents').find('input[type="checkbox"]');

                resetCaptchas();
                $captchaWrapper.slideDown();
                $newsletterMessage.slideUp(150);

                $emailInput.prop('readonly', true);

                onCompleted = function() {
                    $captchaWrapper.slideUp(250);

                    if (!$newsletterForm.valid()) {
                        resetCaptchas();
                        $emailInput.prop('readonly', false);
                        return
                    }

                    $submitButton
                        .prop('disabled', true)
                        .addClass('is-loading');

                    Form.ajaxPost(form, function (data) {
                        let msg = data.msg.format;

                        if (!msg) {
                            msg = data.msg;
                        }

                        $newsletterMessage.html(msg);
                        $newsletterMessage.toggleClass('c-msg--error', !data.status);
                        $newsletterMessage.toggleClass('c-msg--success', data.status);

                        if (!data.status) {
                            $emailInput.addClass('error').focus();
                        } else {
                            $emailInput.val('');
                        }

                        resetCaptchas();
                        $emailInput.prop('readonly', false);
                        $consentCheckbox.prop('checked', false);
                        $submitButton.prop('disabled', false).removeClass('is-loading');
                        $newsletterMessage.slideDown(250);
                    }, 'json');
                }

                return false;
            }
        });
    }
});